var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedinBurgerWhite = function SvgLinkedinBurgerWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 51,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49.878,
    height: 49.878,
    x: 0.061,
    y: 0.355,
    fill: "#717172",
    rx: 24.939
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34.975 26.222V33.1h-4.026v-6.458c0-1.594-.587-2.684-2.013-2.684-1.09 0-1.762.755-2.013 1.426a3.1 3.1 0 0 0-.168 1.006v6.71h-4.026s.084-10.904 0-11.994h4.026v1.677c.503-.838 1.51-2.013 3.607-2.013 2.6 0 4.613 1.762 4.613 5.452M18.535 15.32c-1.342 0-2.265.922-2.265 2.097s.84 2.096 2.181 2.096c1.426 0 2.265-.922 2.265-2.096.084-1.259-.755-2.097-2.18-2.097M16.522 33.1h4.026V21.106h-4.026z"
  })));
};
export default SvgLinkedinBurgerWhite;